<template>
	<router-view/>
</template>

<script>
export default {
	name: "ArtworkView"
};
</script>

<style lang="scss">

</style>
